import { colors, s4, s8 } from '@ardoq/design-tokens';
import type { SpaceVariant } from '@ardoq/layout';
import type { OverlayIndicatorOrientation } from './types';

export const BAR_COLOR = colors.borderFocus;

export const GRID_MIN_COLUMN_WIDTH = '200px';

/** `GRID_GAP_SIZE` must stay the pixel value of `GRID_GAP` — the grid drop indicator is centred in the gutter. */
export const GRID_GAP: SpaceVariant = 'small';
export const GRID_GAP_SIZE = s8;

/** `WRAP_GAP_SIZE` must stay the pixel value of `WRAP_GAP` — the wrap drop indicator is centred in the gutter. */
export const WRAP_GAP: SpaceVariant = 'xsmall';
export const WRAP_GAP_SIZE = s4;

export const OVERLAY_INDICATOR_GAP_SIZE = {
  grid: GRID_GAP_SIZE,
  wrap: WRAP_GAP_SIZE,
} satisfies Record<OverlayIndicatorOrientation, string>;
